import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react'

type SetValue<T> = Dispatch<SetStateAction<T>>

function useLocalStorage<T>(key: string, initialValue: T): [T, SetValue<T>] {
  const readStorageValue = useCallback((): T => {
    try {
      const item = localStorage.getItem(key)
      return item ? JSON.parse(item ?? '{}') : initialValue
    } catch (error) {
      return initialValue
    }
  }, [initialValue, key])

  const [storageValue, setStorageValue] = useState<T>(readStorageValue)

  const setValue: SetValue<T> = (newValue) => {
    try {
      return localStorage.setItem(key, JSON.stringify(newValue))
    } catch (error) {
      setStorageValue(newValue)
    }
  }

  useEffect(() => {
    setStorageValue(readStorageValue())
  }, [])

  return [storageValue, setValue]
}

export default useLocalStorage
